import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import SuccessStories from './components/sections/SuccessStories';
import StoryDetail from './components/sections/StoryDetail';
import Stories from './components/pages/Stories';
import VolunteerForm from './components/sections/VolunteerForm';
import Contact from './components/sections/Contact';
import Blog from './components/sections/Blog';
import AboutUs from './components/pages/AboutUs';
import AboutUsSection from './components/sections/AboutUsSection';
import FloatingVolunteerButton from './components/common/FloatingVolunteerButton';
import ContactUsTile from './components/sections/ContactUsTile';

export type Language = 'en' | 'hi';

export const LanguageContext = React.createContext<{
  language: Language;
  setLanguage: (lang: Language) => void;
}>({
  language: 'en',
  setLanguage: () => {},
});

function App() {
  const [language, setLanguage] = useState<Language>('en');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Header />
          
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <Services />
                  <SuccessStories />
                  <AboutUsSection />
                  <ContactUsTile />
                </>
              } />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/services" element={<Services />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/stories/:id" element={<StoryDetail />} />
              <Route path="/volunteer" element={<VolunteerForm />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>

          <FloatingVolunteerButton />
          <Footer />
        </div>
      </Router>
    </LanguageContext.Provider>
  );
}

export default App;
